/**
 * 
// 描边连接类型
export type StrokeLinejoin = 'miter' | 'round' | 'bevel';

// 描边端点类型
export type StrokeLinecap = 'butt' | 'round' | 'square';

// 主题
export type Theme = 'outline' | 'filled' | 'two-tone' | 'multi-color';
 * 
 */

const base = {
    size: 16,
    strokeWidth: 4,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
}

function initColors(
    theme, 
    customColor = ['#000000', '#000000', '#000000', '#000000'], 
    isCurrentColor = true) {
    const colors = Array(3).fill(customColor[0]);
    // 以下为留白逻辑
    // 线性
    if (theme === 'outline') {
        colors[0] = isCurrentColor ? 'currentColor' : customColor[0];
        colors[1] = '#ffffff';
        colors[2] = isCurrentColor ? 'currentColor' : customColor[0];
    }
    // 面性
    if (theme === 'filled') {
        colors[0] = isCurrentColor ? 'currentColor' : customColor[1];
        colors[1] = isCurrentColor ? 'currentColor' : customColor[1];
        colors[2] = '#ffffff';
    }
    // 双色
    if (theme === 'two-tone') {
        colors[0] = customColor[0];
        colors[1] = customColor[1];
        colors[2] = customColor[0];
    }
    // 多色
    if (theme === 'multi-color') {
        colors[0] = customColor[0];
        colors[1] = customColor[1];
        colors[2] = customColor[2];
    }
    return colors;
}

function initSize(size, isFontSize = false) {
    return isFontSize ? '1em' : `${size}px`;
}

export default {
    name: 'commonIconSetting',
    cName: '设置',
    render(config) {
        const props = {
            ...base,
            ...config,
            size: initSize(config.size, config.isFontSize),
            colors: initColors(config.theme, config.colors, config.isCurrentColor)
        }
        return this.svgFn(props);
    },
    svgFn: (props) => (
        `
        <svg width="${props.size}" height="${props.size}" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
            <g fill="none" fill-rule="evenodd">
                <g transform="translate(4.68 4)" stroke-linecap="${props.strokeLinecap}" stroke-linejoin="${props.strokeLinejoin}" stroke-width="${props.strokeWidth}">
                    <path d="M22.54 0a1 1 0 0 1 .97.757l1.322 5.288a14.984 14.984 0 0 1 3.814 2.206l5.244-1.5a1 1 0 0 1 1.141.461l3.22 5.576a1 1 0 0 1-.171 1.219l-3.92 3.79a15.123 15.123 0 0 1 0 4.406l3.92 3.79a1 1 0 0 1 .17 1.22l-3.219 5.575a1 1 0 0 1-1.14.461l-5.245-1.5a14.984 14.984 0 0 1-3.814 2.206l-1.322 5.288a1 1 0 0 1-.97.757H16.1a1 1 0 0 1-.97-.757l-1.322-5.288a14.984 14.984 0 0 1-3.814-2.206l-5.244 1.5a1 1 0 0 1-1.141-.461L.39 27.212a1 1 0 0 1 .171-1.219l3.92-3.79a15.123 15.123 0 0 1 0-4.406l-3.92-3.79a1 1 0 0 1-.17-1.22L3.61 7.213a1 1 0 0 1 1.14-.461l5.245 1.5a14.984 14.984 0 0 1 3.814-2.206L15.13.757a1 1 0 0 1 .97-.757h6.439z" stroke="${props.colors[0]}" fill="${props.colors[1]}"/>
                    <circle stroke="${props.colors[2]}" cx="19.321" cy="20" r="7"/>
                </g>
            </g>
        </svg>
        `
    )
};
